class mobileMenu {
  constructor() {
    const mobileMenu = document.querySelector('.mobile-toggle')
    const dropdownMenu = document.querySelector('.mobile-nav-dropdown')
    let timeOut = null
    function toggleMobileMenu() {
      const mainMenu = document.querySelector('.nav-mobile')
      mainMenu.classList.toggle('open')
      if (mobileMenu.textContent === 'MENU') {
        if (timeOut) clearTimeout(timeOut)
        dropdownMenu.style.display = 'block'
        mobileMenu.textContent = 'CLOSE'
      } else {
        mobileMenu.textContent = 'MENU'
        timeOut = setTimeout(() => {
          dropdownMenu.style.display = 'none'
        }, 300)
      }
    }

    mobileMenu.addEventListener('click', () => {
      toggleMobileMenu()
    })
  }
}

export default mobileMenu
